import { Divider, Grid, useMediaQuery } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import popupStyle from "../../../../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisAudio.module.scss";
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import GlobalButton from '../../../../../utility/globalButton/button';
import { UserContext, UserContextPayload } from '../../../../../../context/userContext';
import WebhookConfig from './webhookConfig';
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../../context/flowBuilderContext';
import { generateUUID } from '../../../../../../utils/constants';
import { WorkflowContext, WorkflowContextPayload } from '../../../../../../context/workflowContext';
import { extractKeyNameFromPath, getInsideArrayFlagFromPath, replaceNumberWithIndexInPath } from '../../../flowBuilderConstants';
import { useWebhookStore } from '../../../../../../store/webhookStore';
import { isCurrentViewVersionPublished } from '../../../utilityFunctions';

export interface metaDataType {
    metadata_type_id: string
}

const WebHookPopupConfig = (props: any) => {

    const { actionData, stepAction, setFlagWebhookPopup, getOrganizationConfiguredWebhooks } = props;
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;

    const { onChangeCurrentActiveNodeConfig, nodes, onBlurOfFallBackOfBtnVar, currentActiveNodeConfig } = useContext(FlowBuilderContext) as FlowBuilderContextPayload
    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload 
    
    const configuredWebhookData = useWebhookStore((state) => state.configuredWebhookData)

    const [tempActionData, setTempActionData] = useState(actionData)

    const [flagShowResponseData, setFlagShowResponseData] = useState<boolean>(false);

    const [payload, setPayload] = useState<any>({
        webhook_organization_id: null,
        expiry_timestamp: "",
        action_await_webhook_identifier_field_data: [],
        action_await_webhook_save_variable: [],
    });
    const largeScreen = useMediaQuery('(max-width : 1600px) and (min-width : 0px)');

    const disabledSaveBtn = () => {
        if (payload.webhook_organization_id && payload.expiry_timestamp) {
            if (payload.action_await_webhook_identifier_field_data?.some((fieldData: any) => fieldData?.chatbot_custom_variable_configuration_id || fieldData?.metadata_type_id)) { //atleast one of them is dynamic or meta data
                if(flagShowResponseData){
                    if(!payload.action_await_webhook_save_variable?.some((fieldData: any) => fieldData?.chatbot_custom_variable_configuration_id)){
                        return true; 
                    }
                }
                return false
            } 
            return true;
        } else {
            return true;
        }
    } 

    const handleSaveClick = () => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        const updated_action_data = {
            action_await_webhook_id: actionData?.action_await_webhook_id ? actionData?.action_await_webhook_id : generateUUID(),
            expiry_timestamp: payload.expiry_timestamp,
            webhook_organization_id: payload.webhook_organization_id,
            action_await_webhook_identifier_field_data: payload.action_await_webhook_identifier_field_data?.filter((field: any) => {
                return (field?.action_await_webhook_identifier_variable_fallback_value?.length > 0 || field?.chatbot_custom_variable_configuration_id || field?.metadata_type_id);
            }),
            action_await_webhook_save_variable: payload.action_await_webhook_save_variable?.filter((field: any) => {
                return (field?.chatbot_custom_variable_configuration_id);
            })
        }
        onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id,
            updated_action_data,
            {
                updateType: "editExistingStepAction"
            }
        )
        onBlurOfFallBackOfBtnVar(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id,
            updated_action_data,
            {
                updateType: "editExistingStepAction"
            }
        );
        setFlagWebhookPopup(false);
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }

    const handleCancelClick = () => {
        setPayloadFromActionData(tempActionData);
        if (tempActionData?.action_await_webhook_save_variable && tempActionData?.action_await_webhook_save_variable?.length > 0) {
            setFlagShowResponseData(true);
        } else {
            setFlagShowResponseData(false);
        }
    } 

    function extractJsonPaths(data: any): {
        path: string;
        key: string;
        value: any;
        insideArray: boolean;
    }[] {
        const results: {
            path: string;
            key: string;
            value: any;
            insideArray: boolean;
        }[] = [];

        function traverse(current: any, pathParts: string[], insideArray: boolean, currentKey: string | null) {
            if (typeof current !== 'object' || current === null) {
                results.push({
                    path: 'json' + pathParts.join(''),
                    key: currentKey ?? '',   // fallback if null
                    value: current,
                    insideArray,
                });
                return;
            }

            if (Array.isArray(current)) {
                // current.forEach((item) => {
                //     traverse(item, [...pathParts, `[INDEX]`], true, currentKey);
                // }); 

                const uniqueKeys = new Set<string>(); // collect all unique keys across objects in the array
                current.forEach(item => {
                    if (item && typeof item === 'object' && !Array.isArray(item)) {
                        Object.keys(item).forEach(k => uniqueKeys.add(k));
                    }
                }); 

                // traverse each unique key once
                uniqueKeys.forEach(key => {
                    const exampleValue = current.find(item => item && typeof item === 'object' && key in item)?.[key];
                    traverse(exampleValue, [...pathParts, `[INDEX]`, `["${key}"]`], true, key);
                });
                
            } else {
                for (const key in current) {
                    traverse(current[key], [...pathParts, `["${key}"]`], insideArray, key);
                }
            }
        }

        traverse(data, [], false, null);
        return results;
    }

    const setPayloadFromActionData = (actionData: any) => {   
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const integratedWebhook = configuredWebhookData?.find((webhook) => webhook.webhook_organization_id == actionData?.webhook_organization_id);
        const extractedFields = extractJsonPaths(JSON.parse(integratedWebhook?.webhook_external?.sample_webhook_response_json || "") || "");

        setPayload((prevState: any) => ({
            ...prevState,
            webhook_organization_id: actionData.webhook_organization_id,
            expiry_timestamp: actionData.expiry_timestamp,
            action_await_webhook_identifier_field_data: extractedFields?.map((field) => {
                const path = field?.path; 
                const alreadyExistsField = actionData.action_await_webhook_identifier_field_data?.find((field: any) => {
                    return replaceNumberWithIndexInPath(field?.identifier_field_path) == path;
                }); 
                if(alreadyExistsField){
                    return {
                        ...alreadyExistsField, 
                        key: extractKeyNameFromPath(alreadyExistsField?.identifier_field_path), 
                        insideArray: getInsideArrayFlagFromPath(alreadyExistsField?.identifier_field_path),
                    }
                } else {
                    return {
                        ...field,
                        action_await_webhook_identifier_field_id: generateUUID(),
                        chatbot_custom_variable_configuration_id: null,
                        metadata_type_id: null,
                        action_await_webhook_identifier_variable_fallback_value: "",
                        identifier_field_path: field.path,
                        variable_type: null
                    }
                }
            }),
            action_await_webhook_save_variable: extractedFields?.map((field) => {
                const path = field?.path;
                const alreadyExistsField = actionData.action_await_webhook_save_variable?.find((field: any) => {
                    return replaceNumberWithIndexInPath(field?.field_value_path) == path;
                }); 
                if(alreadyExistsField){
                    return {
                        ...alreadyExistsField, 
                        key: extractKeyNameFromPath(alreadyExistsField?.field_value_path), 
                        insideArray: getInsideArrayFlagFromPath(alreadyExistsField?.field_value_path), 
                    }
                } else {
                    return {
                        key: field.key,
                        action_await_webhook_save_variable_id: generateUUID(),
                        chatbot_custom_variable_configuration_id: null,
                        fallback_value: "",
                        path: field.path,
                        field_value_path: field.path, 
                        insideArray: field?.insideArray,
                    }
                }
            })
        })); 

        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    useEffect(() => {
        if (actionData?.webhook_organization_id) {
            setPayloadFromActionData(actionData);
            if (actionData.action_await_webhook_save_variable.length > 0) {
                setFlagShowResponseData(true);
            }
        }
    }, [])
    return (
        <>
            <Grid container className={`${globalStyles.fullHeight} ${globalStyles.zIndex1} ${globalStyles.flexColumn}`} gap={"20px"} padding={"30px"} flexWrap={"nowrap"}>
                <Grid item className={`${globalStyles.fullwidth} ${globalStyles.textCenter}`}>
                    <span className={popupStyle.popupTitleStyle}>Await Webhook</span>
                </Grid>
                <Grid item>
                    <Divider style={{ opacity: "0.2", color: "#9D9D9D", border: "0.2px solid #9D9D9D" }} />
                </Grid>
                <Grid item className={`${globalStyles.fullwidth}`} height={"85%"} overflow={"auto"}>
                    <WebhookConfig
                        payload={payload}
                        setPayload={setPayload}
                        getOrganizationConfiguredWebhooks={getOrganizationConfiguredWebhooks}
                        flagShowResponseData={flagShowResponseData}
                        setFlagShowResponseData={setFlagShowResponseData} 
                        extractJsonPaths={extractJsonPaths} 
                        stepAction={stepAction}
                    />
                </Grid>
                <Grid item className={`${globalStyles.fullwidth}`} mt={1}>
                    <Grid container direction={"row"} gap={2} justifyContent={"center"}>
                        <Grid item>
                            <GlobalButton
                                buttonText={"Cancel"}
                                className='borderedButtonStyle'
                                sx={{ minWidth: "130px", fontSize: largeScreen ? "13px !important" : "" }} 
                                disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                onClick={() => {
                                    handleCancelClick();
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <GlobalButton
                                buttonText={"Save"}
                                className='primaryButtonStyle'
                                sx={{ minWidth: "130px" }}
                                disabled={disabledSaveBtn() || isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                onClick={() => {
                                    handleSaveClick();
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default WebHookPopupConfig
